module.exports = __webpack_public_path__ + "src/assets/img/ramblertop.f911afb1.jpg";